import { useEffect, useRef } from 'react';
import useSessionManager from './useSessionManager';

export default () => {
  const sessionManager = useSessionManager();
  const sessionManagerRef = useRef(sessionManager);
  const { search } = window.location;

  useEffect(() => {
    sessionManagerRef.current = sessionManager;
  });

  useEffect(() => {
    const { current: currentSessionManager } = sessionManagerRef;

    if (currentSessionManager) {
      if (search && !currentSessionManager.isRunningSilent) {
        currentSessionManager.session = search;
      }
    }

    window.parent.postMessage(
      {
        type: 'AUTH_CALLBACK',
        data: search,
      },
      window.location.origin,
    );
  }, [search]);
};
